module.exports = __webpack_public_path__ + "83727102778886030e1e9dab07cc505e.svg";